export default __webpack_public_path__ + "static/media/about-btm-image2-mobile.4c0341be.png";